var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_arrow_forward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 52 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7071 4.79285L20.4142 12.5L12.7071 20.2071L11.2929 18.7928L16.5858 13.5H4V11.5H16.5858L11.2929 6.20706L12.7071 4.79285Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowForward);
export default __webpack_public_path__ + "static/media/ic_arrow_forward.de44ca701be9490e5c2fdbc59813478a.svg";
export { ForwardRef as ReactComponent };